import { getUrl } from "functions/BaseAxios";
import { currency } from "functions/redux/general/action";
import { RootStore } from "functions/redux/store";
import i18n from "i18n/config";
import moment from "moment";
import { FC } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import NcImage from "shared/NcImage/NcImage";

export const paymentStatus = (trip: any) => {
    return trip.cancellationStatus != null
        ? i18n.t('cancelled')
        : Number(trip.isPaymentSuccess) === 1
            ? Number(trip.tripStatus) === 1
                ? i18n.t('trip_is_going')
                : Number(trip.tripStatus) === 2
                    ? i18n.t('trip_completed')
                    : i18n.t('payment_confirmed')
            : trip.stripePaymentIntent === null && Number(trip.isDeclined) === 0
                ? i18n.t('waiting_conf')
                : trip.stripePaymentIntent != null &&
                    Number(trip.isPaymentSuccess) === 0 &&
                    ['3', '4'].indexOf(String(trip.tripStatus)) < 0
                    ? i18n.t('waiting_payment')
                    : Number(trip.tripStatus) === 4
                        ? i18n.t('expired')
                        : '';
}

export const TripTypeBadge: FC<{ item: any, className?: string }> = ({ item, className = '' }) => {
    return (
        <span className={`${className} line-clamp-1  text-white py-1 px-2 md:px-4 mr-2  mt-1 rounded-md capitalize text-xs font-medium text-center text-white ${item.isOpenTrip || String(item.isOpenTrip) ===
            '1' ? 'bg-yellow-400' : 'bg-indigo-900'} `} >
            {`${item.isOpenTrip ? 'Open Trip' : 'Private Trip'} `
            }
        </span >
    );
}
const FullTripCard: FC<{ trip: any }> = ({ trip }) => {
    const { user } = useSelector((state: RootStore) => state);

    const thumb = trip.product.file[0];

    return (<div
        className={`nc-PropertyCardH group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-lg overflow-hidden hover:shadow-xl transition-shadow break-inside mb-4`}
        data-nc-id="PropertyCardH"
    >

        <Link
            to={`booking-detail?id=${trip.id}`}
            className="flex flex-col w-full p-4"
        >

            <div className="flex flex-row w-full justify-center object-cover">

                <NcImage
                    className="rounded-lg h-full  w-32 mr-2 hidden md:block"
                    src={thumb.urls ? getUrl(typeof thumb.urls === "string" ? JSON.parse(thumb.urls)[2] : thumb.urls[2]) : thumb} />
                <div className="flex-1 flex-col space-y-2">
                    <div>
                        <span className="text-xs md:text-sm text-neutral-500 dark:text-neutral-400">
                            {trip.product.isOpenTrip ? `${moment(trip.product.startTripDate).format('LL')} -  ${moment(trip.product.endTripDate).format('LL')}` : `${moment(trip.startDate).format('LL')} -  ${moment(trip.endDate).format('LL')}`}
                        </span>

                    </div>

                    <div className="flex flex-col items-start space-y-2" style={{marginTop:0}}>
                        <h2 className={`font-medium capitalize text-sm md:text-lg `}>
                            <span className="line-clamp-2">{trip?.product?.title ?? trip.product?.highlight}</span>
                        </h2>
                        {String(user.credential.isGuide) === '0' ? (
                        <h2 className={`font-medium capitalize text-sm md:text-md `} style={{marginTop:0}}>
                            <span className="line-clamp-2">{trip?.productOwner?.profile?.displayName}</span>
                        </h2>) 
                        :<h2 className={`font-medium capitalize text-sm md:text-md `} style={{marginTop:0}}>
                            <span className="line-clamp-2">{trip?.customer?.profile?.displayName}</span>
                        </h2>}
                        <h2 className={` font-bold capitalize text-md text-center `}>
                            <span className="line-clamp-1">{currency(trip.totalPrice)}</span>
                        </h2>
                    </div>
                </div>
                <div className="flex-col justify-center items-center space-y-2">
                    <TripTypeBadge item={trip.product} />

                </div>
            </div>
            <div className="flex flex-row w-full items-center justify-between mt-2">
               {String(user.credential.isGuide) !== '0' ? (
                    <span className="text-xs font-medium bg-yellow-600 text-white py-1 px-2 md:px-4 rounded-full mt-2">
                    {parseInt(user.credential.id) === parseInt(trip.customer.id) ? 'You Book' : 'Guide Booking'}
                    </span>
               ) : <div></div>}
                <span className="text-primary-6000 text-xs  font-medium">
                    {paymentStatus(trip)}
                </span>
            </div>


        </Link>
    </div >);
}

export default FullTripCard;